export const en = {
    'status-new': 'New',
    'status-no': 'Rejected',
    'status-waiting': 'Pending approval',
    'status-yes': 'Accepted'
};
